import React from 'react';
import { Button } from './ui/button';
import { Check, Sparkles } from 'lucide-react';
import { pricingPackages } from '../mockData';

const Pricing = () => {
  return (
    <section id="packages" className="py-24 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-cyan-800 text-sm font-semibold tracking-wider uppercase mb-4">
            PRICING PACKAGES
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Choose Your Cinema Experience
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Competitive pricing with customized solutions tailored to your needs and space. All
            packages can be fully customized.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {pricingPackages.map((pkg) => (
            <div
              key={pkg.id}
              className={`relative p-8 rounded-2xl border-2 transition-all duration-300 bg-white flex flex-col ${
                pkg.popular
                  ? 'border-cyan-700 shadow-xl shadow-cyan-700/20'
                  : 'border-cyan-700/30 hover:border-cyan-700'
              }`}
            >
              {pkg.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-4 py-1 bg-cyan-800 rounded-full text-sm font-semibold text-white shadow-lg">
                  Most Popular
                </div>
              )}

              <div className="mb-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.name}</h3>
                <p className="text-gray-600 text-sm min-h-[40px]">{pkg.description}</p>
              </div>

              <div className="mb-6">
                <div className="text-4xl font-bold text-gray-900 mb-2">{pkg.price}</div>
                <div className="text-sm text-cyan-800">Customizable package</div>
              </div>

              <ul className="space-y-3 mb-8 flex-grow">
                {pkg.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-3 text-gray-700">
                    <Check className="w-5 h-5 text-cyan-800 flex-shrink-0 mt-0.5" />
                    <span className="text-sm leading-relaxed">{feature}</span>
                  </li>
                ))}
              </ul>

              <Button
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className={`w-full py-6 rounded-lg transition-all duration-200 mt-auto ${
                  pkg.popular
                    ? 'bg-cyan-800 hover:bg-cyan-900 text-white shadow-lg shadow-cyan-800/30'
                    : 'bg-gray-800 hover:bg-gray-900 text-white'
                }`}
              >
                Get Started
              </Button>
            </div>
          ))}
        </div>

        {/* Custom Solution Card */}
        <div className="max-w-4xl mx-auto p-8 rounded-2xl bg-gradient-to-r from-cyan-50 via-blue-50 to-purple-50 border-2 border-cyan-700/30">
          <div className="flex flex-col md:flex-row items-center gap-6">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-cyan-800 rounded-full flex items-center justify-center shadow-lg shadow-cyan-800/30">
                <Sparkles className="w-8 h-8 text-white" />
              </div>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">Need a Custom Solution?</h3>
              <p className="text-gray-600">
                Every space is unique. Our team can create a completely customized home theatre
                solution tailored to your room dimensions, budget, and preferences.
              </p>
            </div>
            <Button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="flex-shrink-0 bg-cyan-800 hover:bg-cyan-900 text-white font-semibold px-8 py-6 rounded-lg shadow-lg shadow-cyan-800/30"
            >
              Schedule Consultation
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
